<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData
            :coaching="coachingData"
            :calculatedUnits="calculatedUnitsData"/>

        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <form @submit.prevent="submitForm" novalidate class="mt-4">
          <div class="accordion mt-5">
            <!-- Accordion Item 1: Wochenplan -->
            <div class="accordion-item">
              <div class="accordion-header d-flex justify-content-between align-items-center"
                   @click="toggleAccordion(1)">
                <h6 :style="{ color: 'var(--primary)' }">Wochenplan</h6>
                <div class="d-flex align-items-center" @click.stop>
                  <a href="javascript:void(0)"
                     @click="downloadFile(
                         `/portal/assisted-living-coaching/weekly-plans-pdf/${coachingId}`,
                           'wochenplan.pdf'
                         )">
                    <span class="me-2">Wochenplan PDF</span>
                    <img src="../../../../../assets/img/pdf_icon_version4.png"
                         alt="PDF"
                         style="width: 40px;
                       cursor: pointer;"/>
                  </a>
                </div>
              </div>
              <div v-if="activeAccordion === 1" class="accordion-body">
                <div class="row mt-3">
                  <!-- Monday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.mondayDate"
                        label="Montag Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.mondayText"
                        @update:model-value="formData.mondayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

                <div class="row mt-2">
                  <!-- Tuesday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.tuesdayDate"
                        label="Dienstag Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.tuesdayText"
                        @update:model-value="formData.tuesdayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

                <div class="row mt-2">
                  <!-- Wednesday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.wednesdayDate"
                        label="Mittwoch Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.wednesdayText"
                        @update:model-value="formData.wednesdayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

                <div class="row mt-2">
                  <!-- Thursday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.thursdayDate"
                        label="Donnerstag Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.thursdayText"
                        @update:model-value="formData.thursdayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

                <div class="row mt-2">
                  <!-- Friday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.fridayDate"
                        label="Freitag Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.fridayText"
                        @update:model-value="formData.fridayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

                <div class="row mt-2">
                  <!-- Saturday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.saturdayDate"
                        label="Samstag Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.saturdayText"
                        @update:model-value="formData.saturdayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

                <div class="row mt-2">
                  <!-- Sunday -->
                  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
                    <Datepicker
                        v-model="formData.sundayDate"
                        label="Sonntag Datum"
                        position="down"/>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 mb-3">
                    <TextEditor
                        v-model="formData.sundayText"
                        @update:model-value="formData.sundayText = $event"
                        :inputStyle="{ height: '120px' }"
                        label="Beschreibung"/>
                  </div>
                </div>

              </div>
            </div>

            <!-- Accordion Item 2: Notfallplan -->
            <div class="accordion-item">
              <div class="accordion-header d-flex justify-content-between align-items-center"
                   @click="toggleAccordion(2)">
                <h6 :style="{ color: 'var(--primary)' }">Notfallplan</h6>
                <div class="d-flex align-items-center" @click.stop>
                  <a href="javascript:void(0)"
                     @click="downloadFile(
                         `/portal/assisted-living-coaching/emergency-plans-pdf/${coachingId}`,
                           'Notfallplan.pdf'
                         )">
                    <span class="me-2">Notfallplan PDF</span>
                    <img src="../../../../../assets/img/pdf_icon_version4.png"
                         alt="PDF"
                         style="width: 40px;
                       cursor: pointer;"/>
                  </a>
                </div>
              </div>
              <div v-if="activeAccordion === 2" class="accordion-body">
                <AccordionItem
                    title=""
                    :items="formData.emergencyPlans"
                    itemTitleLabel="Umstände"
                    itemDescriptionLabel="Maßnahmen"
                    @addItem="(newItem: EmergencyPlanItem) => addItem('emergencyPlans', newItem)"
                    @deleteItem="(index: number) => removeItem('emergencyPlans', index)"/>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center w-100 mt-5">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup lang="ts">
import assistedLivingCoachingService from '@/api/Unemployed/AssistedLivingCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import {piniaUserStore} from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/AssistedLivingCoaching/CoachingOverviewData.vue';
import AccordionItem from '@/views/App/Portal/AssistedLivingCoaching/FirstInterview/AccordionItem.vue';
import Menu from '@/views/App/Portal/AssistedLivingCoaching/Menu.vue';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import TextEditor from "@/components/TextEditor.vue";
import portalCoachingService from "@/api/Portal/AssistedLivingCoaching";
import {downloadFile} from "@/shared/functions";
import SaveButton from '@/components/button/SaveButton.vue';

interface EmergencyPlanItem {
  title: string;
  description: string;
}

interface WeeklyAndEmergencyPlanFormData {
  coachingId: number;
  mondayDate: string;
  mondayText: string;
  tuesdayDate: string;
  tuesdayText: string;
  wednesdayDate: string;
  wednesdayText: string;
  thursdayDate: string;
  thursdayText: string;
  fridayDate: string;
  fridayText: string;
  saturdayDate: string;
  saturdayText: string;
  sundayDate: string;
  sundayText: string;
  emergencyPlans: EmergencyPlanItem[];
}

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);

const {t} = useI18n();
const coachingData = ref('');
const calculatedUnitsData = ref();
const route = useRoute();
const coachingId = route.params.id as string;
const isLoaded = ref(false);
const isSubmitting = ref(false);
const activeAccordion = ref<number | null>(1); // Tracks the currently open accordion item

const formData = ref<WeeklyAndEmergencyPlanFormData>({
  coachingId: 0,
  mondayDate: '',
  mondayText: '',
  tuesdayDate: '',
  tuesdayText: '',
  wednesdayDate: '',
  wednesdayText: '',
  thursdayDate: '',
  thursdayText: '',
  fridayDate: '',
  fridayText: '',
  saturdayDate: '',
  saturdayText: '',
  sundayDate: '',
  sundayText: '',
  emergencyPlans: [],
});

const formRules = ref({});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    await portalCoachingService.submitWeeklyAndEmergencyPlans(formData.value);
    await getWeeklyAndEmergencyPlansData(coachingId);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getWeeklyAndEmergencyPlansData(coachingId: string) {
  try {
    const {data} = await portalCoachingService.getWeeklyAndEmergencyPlans(+coachingId);
    const weeklyAndEmergencyPlansData = data.data
    console.log(weeklyAndEmergencyPlansData)
    formData.value = {
      coachingId: +coachingId,

      mondayDate: weeklyAndEmergencyPlansData.mondayDate ?? '',
      mondayText: weeklyAndEmergencyPlansData.mondayText ?? '',
      tuesdayDate: weeklyAndEmergencyPlansData.tuesdayDate ?? '',
      tuesdayText: weeklyAndEmergencyPlansData.tuesdayText ?? '',
      wednesdayDate: weeklyAndEmergencyPlansData.wednesdayDate ?? '',
      wednesdayText: weeklyAndEmergencyPlansData.wednesdayText ?? '',
      thursdayDate: weeklyAndEmergencyPlansData.thursdayDate ?? '',
      thursdayText: weeklyAndEmergencyPlansData.thursdayText ?? '',
      fridayDate: weeklyAndEmergencyPlansData.fridayDate ?? '',
      fridayText: weeklyAndEmergencyPlansData.fridayText ?? '',
      saturdayDate: weeklyAndEmergencyPlansData.saturdayDate ?? '',
      saturdayText: weeklyAndEmergencyPlansData.saturdayText ?? '',
      sundayDate: weeklyAndEmergencyPlansData.sundayDate ?? '',
      sundayText: weeklyAndEmergencyPlansData.sundayText ?? '',

      emergencyPlans: (weeklyAndEmergencyPlansData.emergencyPlans ?? []).map((plan: any) => ({
        title: plan.title ?? '',
        description: plan.description ?? '',
      })),
    };

  } catch (error) {
    await ErrorToast(error);
  }
}

async function getCoachingData(coachingId: string) {
  try {
    const {data} = await assistedLivingCoachingService.getAssistedLivingCoaching(+coachingId);
    coachingData.value = data.data;

    const {data: calculatedUnits} = await assistedLivingCoachingService.getCalculatedUnits(+coachingId);
    calculatedUnitsData.value = calculatedUnits.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

// Accordion
const toggleAccordion = (index: number) => {
  activeAccordion.value = activeAccordion.value === index ? null : index;
};

const addItem = (type: keyof WeeklyAndEmergencyPlanFormData, newItem: EmergencyPlanItem) => {
  if (Array.isArray(formData.value[type])) {
    (formData.value[type] as EmergencyPlanItem[]).push(newItem);
  }
};

const removeItem = (type: keyof WeeklyAndEmergencyPlanFormData, index: number) => {
  if (Array.isArray(formData.value[type])) {
    (formData.value[type] as EmergencyPlanItem[]).splice(index, 1);
  }
};

onMounted(async () => {
  await getCoachingData(coachingId);
  await getWeeklyAndEmergencyPlansData(coachingId)
  isLoaded.value = true;
});
</script>

<style scoped>
</style>
